export function numericOnly(val: string): string {
  const cleaned = val.replace(/[^0-9.]/g, '');
  const parts = cleaned.split('.');
  const result = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : cleaned;
  return result === '.' ? '' : result;
}
